import React from 'react';
import { Truck, ShieldCheck, RotateCcw, Headphones } from 'lucide-react';

const FEATURES = [
  {
    icon: Truck,
    title: 'Giao Hàng Siêu Tốc',
    description: 'Miễn phí hóa đơn từ 1.5M',
  },
  {
    icon: ShieldCheck,
    title: 'Bảo Hành Chính Hãng',
    description: 'Cam kết 100% chính hãng',
  },
  {
    icon: RotateCcw,
    title: '30 Ngày Đổi Trả',
    description: 'Thủ tục nhanh gọn 5 phút',
  },
  {
    icon: Headphones,
    title: 'Hỗ Trợ VIP 24/7',
    description: 'Chăm sóc khách hàng ưu tiên',
  },
];

export default function ServiceFeatures() {
  return (
    <section className="py-8 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center md:text-left">
          {FEATURES.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <div key={idx} className="flex flex-col md:flex-row items-center gap-4 p-2">
                <div className="w-12 h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                  <Icon className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 text-sm">{feature.title}</h4>
                  <p className="text-xs text-slate-500 mt-0.5">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}